const ABApplicationMobileCore = require("../core/ABApplicationMobileCore");
module.exports = class ABApplicationMobile extends ABApplicationMobileCore {};
